module.exports = __webpack_public_path__ + "img/gws.b6eecf33.png";